module.exports = __webpack_public_path__ + "img/header-weddingRingsMulticolor.d09f4ed.jpg";